import { useState } from 'react'
import logoWhite from '../../../assets/svg/logo-white.svg'
import { authActions } from '../../../actions/auth'
import { useNavigate } from 'react-router-dom'
import { simpleGetter } from '../../../actions/common'
import { mainApi } from '../../../api/api'
import { useGlobalUserState } from '../../../stores/user'
import { showSnackbar } from '../../../misc/utils'
import Snackbar from '../../../components/Snackbar/Snackbar'

export const Login = () => {
    const navigate = useNavigate()
    const userState = useGlobalUserState()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    const onChangeInput = (setFunc) => (e) => {
        setFunc(e.target.value)
    }

    const signIn = async () => {
        const result = await simpleGetter(mainApi.auth, {
            login: email,
            password
        })
        if (result.token && result.user) {
            const base64Payload = result.token.split(".")[1];
            const decodedPayload = JSON.parse(atob(base64Payload));
            if (!decodedPayload.roles) {
                decodedPayload.roles = decodedPayload.role ? [decodedPayload.role] : ['STUDENT']
            }
            // if (!["TEACHER", "STAFF", "STUFF", "ADMIN", "SUPERADMIN"].some(r => decodedPayload.roles.includes(r))) {
            //     showSnackbar("Неверная роль")
            //     // return
            // }
            const resUser = result.user
            resUser.token = result.token
            resUser.refreshToken = result.refreshToken
            resUser.uniqToken = result.uniqToken
            resUser.uniqUser = result.uniqUser
            resUser.unixRoles = decodedPayload.roles
            userState.set(resUser)
            navigate('/admin/')
        }
    }

    return (
        <div className="grid grid-cols-10 min-h-screen login-wrapper">
            <div className="col-span-5 flex flex-row items-center justify-center">
                <img src={logoWhite} />
            </div>
            <div className='col-span-5 grid grid-cols-12'>
                <div className='col-span-10 pt-20 pb-32'>
                    <div className="bg-white w-full h-full rounded-[20px] shadow-container-1 p-16 flex flex-col">
                        <p className="font-bold text-[40px] text-[#353247]">
                            Войти
                        </p>
                        <div className="flex flex-col mt-4">
                            <p className="font-semibold text-[10px] text-[#818181] mb-1">
                                Адрес электронной почты
                            </p>
                            <input
                                className="login-input border-b-2 border-b-[#2C6A75] px-2 pt-2 pb-3.5 text-xs font-medium text-[#353247]"
                                type="email"
                                onChange={onChangeInput(setEmail)}
                                value={email}
                            />
                        </div>
                        <div className="flex flex-col mt-6">
                            <p className="font-semibold text-[10px] text-[#818181] mb-1">
                                Пароль
                            </p>
                            <input
                                className="login-input border-b-2 border-b-[#2C6A75] px-2 pt-2 pb-3.5 text-xs font-medium text-[#353247]"
                                onChange={onChangeInput(setPassword)}
                                value={password}
                                type="password"
                            />
                        </div>
                        <div className='flex flex-row justify-end mt-12'>
                            <button className='bg-[#427C86] rounded-3xl py-3 px-4 text-white font-semibold text-[15px]' onClick={signIn}>
                                Продолжить
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Snackbar />
        </div>
    )
}